module.exports = __webpack_public_path__ + "media/images/redesign-images/collabs/influencers/logo-heck-59663a71817ad55751ce84f0e70bdd2f.svg";